/**
 * 自訂網域判斷。
 *
 * 有些子站有自己買的網域（例如 www.blackhorn.tw）。在那個網域上：
 *
 *   www.blackhorn.tw/            → 子站首頁
 *   www.blackhorn.tw/location    → 子站底下的 location 頁
 *
 * 也就是網址少掉 `/p/{子站}` 這一段。哪個網域對應哪個子站是後台設定的，
 * 存在資料庫，前端不知道也不需要知道 —— 只要把「目前的網域 + 路徑」丟給
 * 後端的 by-host 端點就會拿到頁面。
 *
 * 所以前端只需要回答一個問題：**現在這個網域是平台自己的，還是某個子站的？**
 * 判斷方式是列出平台自己的網域，其餘一律當自訂網域。用白名單而不是黑名單，
 * 因為子站網域會一直增加，平台自己的網域不會。
 *
 * 這個判斷是同步的（只看 location.hostname），所以路由建立時就能用，
 * 不必等 API 回來 —— 不然首屏會多一段空白。
 */

/**
 * 平台自己的網域一律在 kf-9595.com 底下，子站買的網域不會。
 *
 * 這條是**保命用的**，不是最佳化：判斷方式若只有「不在環境變數列出的網域裡
 * 就當自訂網域」，那麼哪天某個環境的 VUE_APP_MAIN_BASE_URL 沒跟著站台網址
 * 改（例如 ittest 這份設定指到正式站），整個平台會被誤判成自訂網域 ——
 * 於是 30 幾條路由一條都不掛，全站只剩自訂頁面。
 * 那種壞法太大，不能只靠設定檔正確。
 */
const PLATFORM_DOMAIN_SUFFIX = ".kf-9595.com";

/** 平台自己的網域。空值會被濾掉，所以少設某個環境變數不會誤判 */
function platformHosts() {
  const urls = [
    process.env.VUE_APP_MAIN_BASE_URL,
    process.env.VUE_APP_MAIN_SMS_BASE_URL,
    process.env.VUE_APP_MAIN_WT_BASE_URL,
    process.env.VUE_APP_MAIN_AICHAT_BASE_URL,
  ];

  const hosts = [];
  urls.forEach((url) => {
    if (!url) return;
    try {
      hosts.push(new URL(url).hostname.toLowerCase());
    } catch (e) {
      // 設定值不是合法網址就當沒設，不要讓整個判斷炸掉
    }
  });

  return hosts;
}

/**
 * 現在是不是跑在某個子站的自訂網域上。
 *
 * localhost / 127.0.0.1 一律當平台 —— 本機開發要能照原本的 /p/{slug} 走，
 * 否則所有既有路由都會被當成自訂網域的頁面。
 */
export function isCustomDomain() {
  if (typeof window === "undefined") return false;

  const host = window.location.hostname.toLowerCase();
  if (!host || host === "localhost" || host === "127.0.0.1" || host === "[::1]") return false;

  // 保命條件，見 PLATFORM_DOMAIN_SUFFIX
  if (host === "kf-9595.com" || host.endsWith(PLATFORM_DOMAIN_SUFFIX)) return false;

  return !platformHosts().includes(host);
}

/** 目前的網域主機名，要傳給後端的 by-host 端點 */
export function currentHost() {
  return typeof window === "undefined" ? "" : window.location.hostname.toLowerCase();
}
